import {installTouchLayout} from './input/touchLayoutEditor';
import {installCommsUi} from './net/commsUi';
import {installPartyPvpUi} from './net/partyPvpUi';
import Phaser from 'phaser';
import './styles.css';
import './mobileCombatHud.css';
import './hudHierarchy.css';
import './buttonStates.css';
import './resourceBars.css';
import './contextActions.css';
import './feedback.css';
import './confirmation.css';
import './hudDensity.css';
import './statusSources.css';
import './equipmentCompare.css';
import {installHudDetailsUi} from './game/hudDetailsUi';
import './battleSpace.css';
import {installGameDisplay} from './game/gameDisplay';
import {installConfirmationUi} from './game/confirmationUi';
import {installFeedbackUi} from './game/feedbackUi';
import { BootScene } from './scenes/BootScene';
import { LobbyScene } from './scenes/LobbyScene';
import { BanBangPhiScene } from './scenes/BanBangPhiScene';
import {TownScene} from './scenes/TownScene';
import {WorldTravelScene} from './scenes/WorldTravelScene';
import {StoryBattleScene} from './scenes/StoryBattleScene';
import {angledRegion} from '../../shared/regions.mjs';
import {installCampaignCutscenes} from './game/campaignUi';
import {onlineSession} from './net/online';
import {getPreferences} from './game/preferences';
import {installHighDensityRendering} from './game/renderResolution';
import {installPreferences} from './game/settingsUi';
import {installPoseUi} from './game/poseUi';
import {installJourneyUi} from './game/journeyUi';
import { installGameInput } from './input';
import { installOnlineLobby } from './net/lobbyUi';
import { setupLoadingScreen } from './game/loadingScreen';

setupLoadingScreen();
installGameInput();
const releaseFeedback=installFeedbackUi();
import.meta.hot?.dispose(releaseFeedback);
const releaseConfirmation=installConfirmationUi();
import.meta.hot?.dispose(releaseConfirmation);
const releaseHudDetails=installHudDetailsUi();
import.meta.hot?.dispose(releaseHudDetails);

export const game = new Phaser.Game({
  type: Phaser.AUTO,
  fps:{target:getPreferences().fps,limit:getPreferences().fps},
  parent: 'game',
  backgroundColor: '#0d1322',
  scale: { mode: Phaser.Scale.RESIZE, autoCenter: Phaser.Scale.CENTER_BOTH, width: '100%', height: '100%' },
  render: { antialias: true, pixelArt: false, roundPixels: false },
  scene: [BootScene, LobbyScene, TownScene, BanBangPhiScene,WorldTravelScene,StoryBattleScene],
});

installHighDensityRendering(game);
installPreferences(game);installTouchLayout();
installOnlineLobby(game);
installCommsUi();
installPartyPvpUi();
installPoseUi();
installJourneyUi();
installCampaignCutscenes();
let storyReturn:string|undefined;
game.events.on(Phaser.Core.Events.POST_STEP,()=>{
 const state=onlineSession.current,me=state.snapshot?.players.find(p=>p.id===state.playerId);
 if(me?.storyBattle&&!game.scene.isActive('story-battle')){const active=game.scene.getScenes(true).find(s=>['town','ban-bang-phi'].includes(s.scene.key));if(active){storyReturn=active.scene.key;game.scene.pause(storyReturn);game.scene.run('story-battle');}}
 else if(!me?.storyBattle&&game.scene.isActive('story-battle')){
  game.scene.stop('story-battle');
  const destination=angledRegion(me?.mapId??'')?'town':'ban-bang-phi';
  // Respawn/area updates may already have replaced the paused scene during battle.
  if(storyReturn&&storyReturn!==destination)game.scene.stop(storyReturn);
  if(game.scene.isPaused(destination))game.scene.resume(destination);
  else if(!game.scene.isActive(destination))game.scene.start(destination);
  storyReturn=undefined;
 }
});
window.addEventListener('open-world-travel',()=>{if(game.scene.isActive('world-travel'))return;const active=game.scene.getScenes(true).find(s=>['town','ban-bang-phi'].includes(s.scene.key));if(!active)return;game.scene.pause(active.scene.key);game.scene.run('world-travel',{returnScene:active.scene.key});});
const releaseDisplay=installGameDisplay(game);
import.meta.hot?.dispose(releaseDisplay);

import './growth.css';

import './skillDetails.css';
import './hotbarEditing.css';
import './hotbarState.css';
